/**
 * VendedorLocalRepository
 *
 * Abstrai o acesso aos vendedores armazenados localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const VendedorLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async listar() {
    return this._api().vendedores.listar();
  },

  async buscar(termo) {
    return this._api().vendedores.buscar(termo);
  },

  async salvar(items) {
    return this._api().vendedores.salvar(items);
  },

  async buscarPorId(id) {
    return this._api().vendedores.buscarPorId(id);
  },

  async contar() {
    return this._api().vendedores.contar();
  },
};

export default VendedorLocalRepository;
